<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="14">
        <!-- 左侧版块 -->
        <el-card class="mt-2">
          <div>
            <b-row>
              <b-col cols="auto" class="mr-auto">
                <h5>
                  {{ formData.scmName }}
                  <b-badge
                    class="ml-2 mr-2"
                    style="font-size: 12px"
                    @click="follow"
                    :variant="
                      formData.isCollected === 'Y' ? 'info' : 'secondary'
                    "
                  >
                    {{ formData.isCollectedName || ' Not Set' }}
                  </b-badge>
                </h5>
                <div class="d-flex">
                  <b-badge class="mr-2" style="font-size: 12px">
                    {{ formData.scmTypeName || 'Not Set' }}
                  </b-badge>
                  <b-badge
                    class="mr-2"
                    style="font-size: 12px"
                    :variant="
                      formData.scmMode === 'B'
                        ? 'primary'
                        : formData.scmMode === 'C'
                        ? 'success'
                        : 'secondary'
                    "
                  >
                    {{ formData.scmModeName || 'Not Set' }}
                  </b-badge>
                  <b-badge class="mr-2" style="font-size: 12px">
                    {{ formData.scmCategoryName || 'Category Not Set' }}
                  </b-badge>
                </div>
                <div class="mt-2">
                  <el-rate v-model="formData.ourRatings" disabled> </el-rate>
                </div>
              </b-col>
              <b-col cols="auto">
                <a
                  v-b-toggle.collapse-info
                  role="button"
                  style="color: #606266"
                >
                  <i
                    v-if="isShowPanel"
                    class="fa fa-chevron-down"
                    title="收起"
                  ></i>
                  <i v-else class="fa fa-chevron-up" title="展开"></i>
                </a>
              </b-col>
            </b-row>
            <b-collapse v-model="isShowPanel" id="collapse-info">
              <div class="mt-2  div-box ">
                <el-row :gutter="5">
                  <el-col :span="20">
                    <span>
                      {{ formData.provinceName || '' }}
                      {{ formData.cityName || '' }}
                      {{ formData.districtName || '' }}
                      {{ formData.scmAddress || '' }}</span
                    >
                  </el-col>
                </el-row>
                <el-row class="mt-2" :gutter="5">
                  <el-col :span="20">
                    <span
                      >{{
                        $l('form_label_supplier_businessLicense') ||
                          '统一社会征信代码'
                      }}：{{ formData.businessLicense || '' }}</span
                    >
                  </el-col>
                </el-row>

                <el-row class="mt-2" :gutter="5">
                  <el-col
                    :span="12"
                    v-for="(item, index) in formData.scmInfoBankList"
                    :key="index"
                  >
                    <el-row class="mt-2" :gutter="5">
                      <el-col :span="24">
                        <span
                          >{{
                            $l('form_label_supplier_bankName') || '开户银行'
                          }}：{{ item.bankName || '' }}</span
                        >
                      </el-col>
                      <el-col :span="24">
                        <span
                          >{{
                            $l('form_label_supplier_bankAccountName') ||
                              '账户名称'
                          }}：{{ item.bankAccountName || '' }}</span
                        >
                      </el-col>
                      <el-col :span="24">
                        <span
                          >{{
                            $l('form_label_supplier_bankAccountNo') ||
                              '银行账号'
                          }}：{{ item.bankAccountNo || '' }}</span
                        >
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row class="mt-2" :gutter="5">
                  <el-col :span="20">
                    <span
                      >{{ $l('form_label_certificate_info') || '相关证书' }}：{{
                        formData.certificateInfo || ''
                      }}</span
                    >
                  </el-col>
                  <el-col :span="20">
                    <span
                      >{{
                        $l('form_label_factory_inspection') || '工厂资质'
                      }}：{{ formData.factoryInspection || '' }}</span
                    >
                  </el-col>
                  <el-col :span="20">
                    <span
                      >{{ $l('form_label_customer') || '适用客户' }}：{{
                        formData.suitableForCustomers || ''
                      }}</span
                    >
                  </el-col>
                  <!-- <el-col :span="12">
                  <span
                    >{{ $l('form_label_supplier_source') || '供应商来源' }}：{{
                      formData.scmSource || ''
                    }}</span
                  >
                </el-col> -->
                </el-row>
                <el-row class="mt-2" :gutter="5" v-if="formData.scmMemo">
                  <el-col :span="20">
                    <span style="font-weight:500;"
                      >{{ $l('form_label_remarks') || '工厂概况' }}：</span
                    >
                  </el-col>
                  <el-col :span="20">
                    <span v-html="formData.scmMemo || ''"></span>
                  </el-col>
                </el-row>
                <el-row
                  class="mt-2"
                  :gutter="5"
                  v-if="formData.scmProductCategory"
                >
                  <el-col :span="20">
                    <span style="font-weight:500;">
                      {{ $l('form_label_main_categories') || '主要品类' }}：
                    </span>
                  </el-col>
                  <el-col :span="20">
                    <span v-html="formData.scmProductCategory || ''"></span>
                  </el-col>
                </el-row>
                <el-row class="mt-2" :gutter="5" v-if="formData.scmCooperation">
                  <el-col :span="20">
                    <span style="font-weight:500;">
                      {{ $l('form_label_cooperation') || '合作意向' }}：
                    </span>
                  </el-col>
                  <el-col :span="20">
                    <span v-html="formData.scmCooperation || ''"> </span>
                  </el-col>
                </el-row>
              </div>
            </b-collapse>
          </div>
        </el-card>
      </el-col>
      <!-- 右侧版块开始 -->
      <el-col :span="10">
        <!-- 联系人信息 -->
        <contacts class="mt-2" ref="contacts" :params="contactsParams" />
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col>
        <!-- 厂商评分 -->
        <rating class="mt-2" ref="rating" :params="ratingParams" />
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="10">
        <!-- 厂商图片 -->
        <scm-images class="mt-2" ref="scmImages" :params="scmImagesParams" />
      </el-col>
      <el-col :span="14">
        <!-- 拜访记录 -->
        <visit class="mt-2" ref="visit" :params="visitParams" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import rating from './components/rating'
import contacts from './components/contacts'
import scmImages from './components/scmimages'
import visit from './components/visit'
export default {
  name: 'resourceManagement-scmInfoDetail',
  components: { rating, contacts, scmImages, visit },
  data() {
    return {
      formData: {
        scmCode: '',
        scmNo: '',
        scmName: '',
        scmNameEn: '',
        scmStatus: '',
        scmStatusName: '',
        scmAddress: '',
        scmMemo: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        scmCategoryCode: '',
        scmCategoryName: '',
        scmCooperation: '',
      },
      isShowPanel: true,
      curParam: {
        scmCode: '',
      },
      contactsParams: { scmCode: '' },
      ratingParams: { scmCode: '' },
      scmImagesParams: { scmCode: '' },
      visitParams: { scmCode: '' },
    }
  },
  // 侦听器
  // watch: {
  //   '$route.params'() {
  //     if (this.$route.params.scmCode) {
  //       console.log('1')
  //       this.formLoad()
  //     }
  //   },
  // },
  mounted() {
    document.body.scrollTop = 0
    this.formLoad()
  },
  activated() {
    document.body.scrollTop = 0
    this.resizeTheChart()
  },
  // computed: {
  //   ratingParams() {
  //     return {
  //       scmCode: this.formData.scmCode,
  //     }
  //   },
  //   contactsParams() {
  //     return {
  //       scmCode: this.formData.scmCode,
  //     }
  //   },
  //   scmImagesParams() {
  //     return {
  //       scmCode: this.formData.scmCode,
  //     }
  //   },
  //   visitParams() {
  //     return {
  //       scmCode: this.formData.scmCode,
  //     }
  //   },
  // },
  methods: {
    formLoad() {
      let scmCode = this.$route.params.scmCode
      this.curParam.scmCode = scmCode
      this.contactsParams.scmCode = scmCode
      this.ratingParams.scmCode = scmCode
      this.scmImagesParams.scmCode = scmCode
      this.visitParams.scmCode = scmCode
      this.refresh()
    },
    refresh() {
      let param = { scmCode: this.curParam.scmCode }
      this.$api.scmInfoDetailApi(param).then((res) => {
        this.formData = res.body
        // this.contactsParams.scmCode = this.formData.scmCode
        // this.ratingParams.scmCode = this.formData.scmCode
        // this.scmImagesParams.scmCode = this.formData.scmCode
        // this.visitParams.scmCode = this.formData.scmCode

        if (this.formData.scmMemo !== null) {
          this.formData.scmMemo = this.formData.scmMemo
            .replace(/ /g, '&nbsp;')
            .replace(/\n/g, '<br/>')
        }
        if (this.formData.scmCooperation !== null) {
          this.formData.scmCooperation = this.formData.scmCooperation
            .replace(/ /g, '&nbsp;')
            .replace(/\n/g, '<br/>')
        }
      })
    },
    resizeTheChart() {
      this.$nextTick(() => {
        this.$refs.rating.resizeTheChart()
      })
    },
    follow() {
      if (this.formData.isCollected === 'Y') {
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_question_follow') || '是否关注该供应商?',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .scmInfoFollowApi({ scmCode: this.curParam.scmCode })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_Follow_successfully') || '提交成功!'
            )
            this.formLoad()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.div-box {
  font-size: 14px;
  color: #666666;
  height: 272px;
  overflow-x: hidden;
}
</style>
